import React, { useEffect, useRef, useState } from "react";
import { getPos } from "../../utils/getElementPosition";
import styles from "./StickyComponent.module.scss";
interface Props {
  children: React.ReactNode;
}
const StickyComponent: React.FC<Props> = ({ children }) => {
  const stickyContainerEl = useRef<HTMLDivElement>(null);
  const stickyContainerPosition = useRef(0);
  const [stickyContainerWidth, setStickyContainerWidth] = useState(0);
  const [stickyContainerX, setStickyContainerX] = useState(0);
  const [sticking, setSticking] = useState(false);

  useEffect(() => {
    let timeOut: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      if (stickyContainerEl.current?.parentElement) {
        const newHeight = stickyContainerEl.current.getBoundingClientRect().top;
        if (newHeight <= 0) {
          stickyContainerEl.current.classList.add(styles.stick);
          setSticking(true);
        }
        if (window.pageYOffset < stickyContainerPosition.current) {
          stickyContainerEl.current.classList.remove(styles.stick);
          setSticking(false);
        }
      }
    };

    const updateStickiContainerPosition = () => {
      if (stickyContainerEl.current) {
        const currentPosition = getPos(stickyContainerEl.current);
        const currentWidth = stickyContainerEl.current.offsetWidth;
        setStickyContainerWidth(currentWidth);
        stickyContainerPosition.current = currentPosition.y;
        setStickyContainerX(currentPosition.x);
      }
    };

    const onResize = () => {
      clearTimeout(timeOut);
      timeOut = setTimeout(() => {
        updateStickiContainerPosition();
      }, 500);
    };

    updateStickiContainerPosition();
    window.addEventListener("resize", onResize);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [stickyContainerWidth, stickyContainerX]);

  return (
    <div
      ref={stickyContainerEl}
      className={styles.stickyComponent}
      {...(sticking && {
        style: {
          width: `${stickyContainerWidth}px`,
          left: `${stickyContainerX}px`,
        },
      })}
      // style={{
      //   width: `${stickyContainerWidth}px`
      // }}
    >
      {children}
    </div>
  );
};
export default StickyComponent;
